import React, { Fragment, Children } from "react"
import PropTypes from "prop-types"
import isNumber from "lodash/isNumber"
import { event } from "../reactGA"
import i18n from "../../i18n"
import config from "../../Config"
import { withRouter } from "react-router"

class Tab extends React.Component {
  render() {
    console.log("tabPanel Props", this.props)
    const {
      tabsData,
      style,
      index,
      isSelected,
      onTabSelect,
      history,
      theme,
    } = this.props
    const { selectedIconUrl, unSelectedIconUrl, label } = tabsData
    let labelStyle
    let imgStyle
    let imgSrc

    if (isSelected) {
      labelStyle = { color: "#fff", fontSize: "12px", marginTop: "2px" }
      imgSrc = selectedIconUrl
      // imgStyle = {width: "40%"};
    } else {
      labelStyle = {
        color: "#ffffff",
        opacity: 0.7,
        fontSize: "12px",
        marginTop: "2px",
      }
      imgSrc = unSelectedIconUrl
      // imgStyle = {width: "35%"};
    }

    if (label === "BID") {
      return (
        <button
          style={{
            backgroundColor: "#fb0e56",
            border: "none",
            padding: "10px",
            minWidth: "92px",
            borderRadius: "20px",
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          // onClick={(_) => onTabSelect(index, label)}
          onClick={() => history.push("/play/all-bids")}
        >
          <span>
            <img
              // src={`${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/other-icons/bid.png`}
              src={theme && theme.navIcons && theme.navIcons.bid}
              alt='Bid'
            />
          </span>
          <span
            style={{
              fontWeight: "500",
              fontFamily: "montserratRegular",
              marginLeft: "10px",
              fontSize: "14px",
            }}
          >
            {i18n.t(label.trim().replace(/\s/g, ""))}
          </span>
        </button>
      )
    } else {
      return (
        <div
          onClick={(_) => onTabSelect(index, label)}
          style={{ ...TabStyle, ...style }}
        >
          {imgSrc && (
            <img
              width='24px'
              height='24px'
              style={imgStyle}
              src={imgSrc}
              alt='tab-Details'
            />
          )}
          <div className='montserratLight' style={labelStyle}>
            {i18n.t(label.trim().replace(/\s/g, ""))}
          </div>
        </div>
      )
    }
  }
}

const TabStyle = {
  flex: 1,
  textAlign: "center",
  border: "none",
  outline: "none",
  cursor: "pointer",
  transition: "0.3s",
  fontSize: 13,
  fontWeight: 500,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
}

export class TabPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: this.props.selectedIndex || 0,
      NumberOfChildren: Children.count(this.props.children),
      views: [],
    }
    this.onTabSelect = this.onTabSelect.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // console.log("componentWillReceiveProps -->>",nextProps,this.props);
    if (
      isNumber(nextProps.selectedIndex) &&
      nextProps.selectedIndex !== this.state.selectedIndex
    ) {
      this.setState({
        selectedIndex: nextProps.selectedIndex,
      })
    }
  }

  onTabSelect(selectedIndex, label) {
    this.setState({
      selectedIndex,
    })
    event({
      category: "Home Page",
      action: label,
    })
  }

  render() {
    console.log("TabPanel props -->>", this.props)
    // console.log("TabPanel state -->>",this.state);
    const { style, children, theme } = this.props
    let { selectedIndex, views } = this.state
    views = []
    const __tabs = Children.map(children, (child, childIndex) => {
      const _childTabSelect =
        child.props && child.props.onTabSelect
          ? (_) => {
              this.onTabSelect(_)
              child.props.onTabSelect(_)
            }
          : undefined
      let _props = {
        index: childIndex,
        key: `tab__${childIndex}`,
        onTabSelect: _childTabSelect || this.onTabSelect,
        isSelected: childIndex === selectedIndex,
      }

      views.push(child.props.children)
      return React.cloneElement(child, _props)
    })

    return (
      <Fragment>
        <div
          className='tab-panel montserratRegular'
          style={{
            ...TabPanelStyle,
            ...style,
            backgroundColor: theme.primaryColor,
          }}
        >
          {__tabs}
        </div>
        {React.cloneElement(views[selectedIndex])}
      </Fragment>
    )
  }
}

const TabPanelStyle = {
  position: "fixed",
  bottom: 0,
  width: "100%",
  height: "72px",
  display: "flex",
  alignItems: "center",
  zIndex: 5,
}

TabPanel.propTypes = {
  style: PropTypes.object,
  heading: PropTypes.string,
}

TabPanel.defaultProps = {
  style: {},
}

export default withRouter(Tab)



// WEBPACK FOOTER //
// ./src/components/tabPanel/index.js